import { Component } from "@angular/core";
import { IFilterAngularComp } from "ag-grid-angular";
import { IDoesFilterPassParams, IFilterParams } from "ag-grid-community";
import { PpsUtilityService } from "../services/pps-utility.service";
import { ISelectOption } from "../shared/models/option";
import { TicketStatus } from "../shared/models/roster/ticket-status";

@Component({
  selector: "pps-employee-filter",
  templateUrl: "./employee-filter.component.html"
})
export class EmployeeFilterComponent implements IFilterAngularComp{
  params!: IFilterParams;
  employees: ISelectOption[] = [];
  selectedEmployees: ISelectOption[] = [];
  employeeName = null;

  constructor(private util: PpsUtilityService){}
  
  agInit(params: IFilterParams): void {
    this.params = params;
    this.employees = params["employees"];
  }

  doesFilterPass(params: IDoesFilterPassParams) {
    const { api, colDef, column, columnApi, context } = this.params;
    const { node } = params;

    let match = false;
    if (this.isSelectFilter()){
      this.selectedEmployees.forEach((emp) => {
        if (emp.text === this.util.getEmployeeName(node.data.employee)){
          match = true;
        }
      });
    }else{
      if (this.isTextFilter()){
        const valueFromGrid = this.util.getEmployeeName(node.data.employee)?.toLowerCase();
        if (valueFromGrid.indexOf(this.employeeName.toLowerCase()) !== -1){
          match = true;
        }
      }
    }

    return match;
  }

  isFilterActive(): boolean {
    return this.isSelectFilter() || this.isTextFilter();
  }

  private isSelectFilter(){
    return this.selectedEmployees && this.selectedEmployees.length > 0;
  }

  private isTextFilter(){
    return this.employeeName !== null;
  }

  getModel() {
    if (!this.isFilterActive()) {
      return null;
    }

    return { value: this.isSelectFilter() ? this.selectedEmployees : this.employeeName };
  }

  setModel(model: any) {
    if (this.isSelectFilter()){
      this.selectedEmployees = model == null ? null : model.value;
    }else{
      this.employeeName = model == null ? null : model.value;
    }
  }

  onChange(data) {
    //console.log(this.selectedEmployees);
    this.employeeName = null;
    this.params.filterChangedCallback();
  }

  onFloatingFilterChanged(employeeName){
    //console.log("floating filter changed: " + employeeName);
    this.employeeName = employeeName;
    this.selectedEmployees = null;
    this.params.filterChangedCallback();
  }
  // onPanelShow(evt){
  //   var elements = document.querySelectorAll('.p-component.p-multiselect-panel');
  //   if (elements && elements.length === 1){
  //     elements[0].classList.add("ag-custom-component-popup");
  //   }
  // }
}